import { createApp, h } from 'vue';
import PrimeVue from 'primevue/config';
import ZipCitySearch from "./vue/components/zipCitySearch.vue";

const branchLocatorApp = "#branchLocatorApp";
if (document.querySelectorAll(branchLocatorApp).length) {
    const resultUrl = document.querySelector(branchLocatorApp).dataset.resultUrl;
    const seedData = {resultUrl:resultUrl,icon:'pi-arrow-right'};

    const branchLocator = createApp({
        data() { return seedData },
        render: () => h(ZipCitySearch)
    }, seedData);

    branchLocator.use(PrimeVue);
    branchLocator.mount(branchLocatorApp);

}
